const API_BASE_URL = process.env.REACT_APP_URL_backend;

// List of endpoints that don't require authentication
const PUBLIC_ENDPOINTS = [
    '/api/users/signup',
    '/api/users/create-account',
    '/api/users/login',
    '/api/verify/initiate',
    '/api/verify',
    '/api/auth/google',
    '/api/auth/google/callback',
    '/api/auth/google/verify-token',
    '/api/auth/check-email',
    '/api/auth/setup-password',
    '/api/auth/forgot-password',
    '/api/auth/verify-reset-code',
    '/api/auth/reset-password',
    '/api/auth/resend-reset-code'
];

const isPublicEndpoint = (endpoint) => {
    return PUBLIC_ENDPOINTS.some(publicEndpoint => endpoint.startsWith(publicEndpoint));
};

export const api = {
    get: async (endpoint) => {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };

            if (!isPublicEndpoint(endpoint)) {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    throw new Error('No authentication token found');
                }
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'GET',
                headers,
                credentials: 'include',
                mode: 'cors'
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    },

    post: async (endpoint, data) => {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };

            if (!isPublicEndpoint(endpoint)) {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    throw new Error('No authentication token found');
                }
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'POST',
                headers,
                credentials: 'include',
                mode: 'cors',
                body: JSON.stringify(data)
            });
            
            const responseData = await response.json();
            
            if (!response.ok) {
                throw {
                    status: response.status,
                    message: responseData.message,
                    code: responseData.code,
                    data: responseData
                };
            }
            
            return responseData;
        } catch (error) {
            console.error('API Call Failed:', error);
            // If it's our structured error, throw it as is
            if (error.status) {
                throw error;
            }
            // Otherwise throw a generic error
            throw {
                status: 500,
                message: 'Failed to make API call',
                code: 'NETWORK_ERROR'
            };
        }
    },

    put: async (endpoint, data) => {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };

            if (!isPublicEndpoint(endpoint)) {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    throw new Error('No authentication token found');
                }
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'PUT',
                headers,
                credentials: 'include',
                mode: 'cors',
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            return response.json();
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    },

    delete: async (endpoint) => {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };

            if (!isPublicEndpoint(endpoint)) {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    throw new Error('No authentication token found');
                }
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'DELETE',
                headers,
                credentials: 'include',
                mode: 'cors'
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            return response.json();
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    }
}; 